// extracted by mini-css-extract-plugin
export default {"stickyContainer":"wVB0iZ","stickyContainerFront":"OKNKcv","stickyContainerBack":"PnHjQR","ctaContainer":"VVjiDb","priceText":"eRM2MH","pricePerDay":"RNSWI1","ctaButton":"xdRmW0"};